@use "../../styles/Constants.scss" as Constants;
@use "../../styles/Colors.scss" as Colors;

$var-sticky-top-offset: -16px;

.form {
	display: grid;
	grid-template-columns: Constants.$val-spacing-s auto Constants.$val-spacing-s;
	background-color: Colors.$col-design-grey12;


	&__header {
		grid-column: 1 / span 3;

		background-color: Colors.$col-white;
		border-bottom: 1px solid Colors.$col-design-grey14;
		padding: Constants.$val-spacing-s Constants.$val-spacing-l;

		display: grid;
		grid-auto-flow: column;
		align-items: center;
		justify-content: space-between;

		&--sticky {
			position: sticky;
			top: $var-sticky-top-offset;
			z-index: 5;
		}
	}

	&__section {
		grid-column: 2 / span 1;

		background-color: Colors.$col-white;
		padding: Constants.$val-spacing-m;
		margin: calc(Constants.$val-spacing-xs + Constants.$val-spacing-s) 0;
		box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);

		&+& {
			margin-top: 0;
		}

	}

	&__section-title {
		font-weight: 400;
		line-height: Constants.$val-lineHeightRegular;
		color: Colors.$col-design-grey10;
		padding: Constants.$val-spacing-s calc(Constants.$val-spacing-xs + Constants.$val-spacing-s);
		text-transform: uppercase;
	}
}
